import React, { Component } from 'react';
import { Modal, Button, Table, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ExportUtil from '../../../common/ExportUtil';

class FinalQuotation extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    show = (record = {}) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            record: {},
            visible: false,
        });
    }

    loadData = () => {
        const { record: { clinicalQuotationId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryFinalQuotationInfo,
            data: { clinicalQuotationId  },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    data: [res.data],
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '最终报价金额（含税）/人民币',
        dataIndex: 'finalTotalPrice',
        key: 'finalTotalPrice',
        width: 120,
        render: text => (text || text == 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
    }, {
        title: '单例价格金额（含税）/人民币',
        dataIndex: 'unitPrice',
        key: 'unitPrice',
        width: 120,
        render: text => (text || text == 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
    }, {
        title: '报价例数',
        dataIndex: 'randomCaseNum',
        key: 'randomCaseNum',
        width: 80,
    }, {
        title: '获标日期',
        dataIndex: 'awardDate',
        key: 'awardDate',
        width: 80,
    }, {
        title: '获标金额（含税）/人民币',
        dataIndex: 'awardAmountCny',
        key: 'awardAmountCny',
        width: 120,
        render: text => (text || text == 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
    }, {
        title: '税率（%）',
        dataIndex: 'taxRate',
        key: 'taxRate',
        width: 80,
    }, {
        title: '获标金额（不含税）/人民币',
        dataIndex: 'awardAmountCnyNoTax',
        key: 'awardAmountCnyNoTax',
        width: 120,
        render: text => (text || text == 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
    }, {
        title: '获标中心数',
        dataIndex: 'awardSiteNum',
        key: 'awardSiteNum',
        width: 80,
    }, {
        title: '获标例数',
        dataIndex: 'awardCaseNum',
        key: 'awardCaseNum',
        width: 80,
    }, {
        title: '获标单例价格金额（不含税）/人民币',
        dataIndex: 'awardAmountPerCaseNoTax',
        key: 'awardAmountPerCaseNoTax',
        width: 120,
        render: text => (text || text == 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
    }, {
        title: '终版报价附件',
        dataIndex: 'file',
        key: 'file',
        width: 120,
        render: (text, record) => {
            const { fileList } = record;
            return (fileList || []).map(el => <a onClick={() => this.downLoadFile(el.fileMateId)}>{el.name}<br /></a>)
        }
    }]

    downLoadFile = (fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    render() {
        const { visible, loading, data, record } = this.state;
        const { evaluateCode, businessOpportunityNum, businessOpportunityStatusShow } = record;
        return (
            <Modal
                title="最终报价"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width="1000px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        临床评估单号：{evaluateCode}&nbsp;&nbsp;&nbsp;&nbsp;业务机会编号：{businessOpportunityNum}&nbsp;&nbsp;&nbsp;&nbsp;业务机会状态：{businessOpportunityStatusShow}
                    </div>
                    <div>
                        <Table
                            bordered
                            dataSource={data}
                            loading={loading}
                            columns={this.getColumns()}
                            scroll={{ x: 500 }}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default FinalQuotation;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/FinalQuotation.js